import React from 'react';
import { HrnbRow, HrnbCol } from '../../../components/controls/HrnbContainer';
import HrnbCard from '../../../components/controls/HrnbCard';
import HrnbSkeleton, { SkeletonList } from '../../../components/controls/HrnbSkeleton';

/**
 * Вкладка "Жюри" страницы баттла
 */
const BattleJudgesTab = ({ judges, participantLoading }) => {
  return (
    <HrnbRow>
      <HrnbCol xs={12}>
        <HrnbCard title="Жюри" className="battle-detail-card">
          {participantLoading ? (
            <SkeletonList count={3} />
          ) : judges.length === 0 ? (
            <div className="no-participants">Жюри ещё не назначено</div>
          ) : (
            <HrnbRow className="judges-grid">
              {judges.map((judge) => (
                <HrnbCol xs={12} sm={6} lg={4} key={judge.id} className="mb-4">
                  <HrnbCard className="judge-card h-100">
                    <div className="judge-card-header">
                      <div className="judge-avatar-placeholder">
                        {judge.name?.charAt(0)?.toUpperCase() ||
                          judge.nickname?.charAt(0)?.toUpperCase() ||
                          judge.username?.charAt(0)?.toUpperCase() ||
                          'J'}
                      </div>
                      <div className="judge-card-badge">Жюри</div>
                    </div>
                    <div className="judge-card-body">
                      <h5 className="judge-name">
                        {judge.name ||
                          judge.nickname ||
                          judge.username ||
                          'Жюри'}
                      </h5>
                      {judge.nickname && (
                        <p className="judge-nickname">@{judge.nickname}</p>
                      )}
                      {judge.city && (
                        <p className="judge-city">📍 {judge.city}</p>
                      )}
                    </div>
                  </HrnbCard>
                </HrnbCol>
              ))}
            </HrnbRow>
          )}
        </HrnbCard>
      </HrnbCol>
    </HrnbRow>
  );
};

export default BattleJudgesTab;
